import { RefundNumber } from '../types/refund-number';
import { RefundType } from '../enums/refund-type';
import { RefundStatus } from '../enums/refund-status';
import { Guid, Nillable } from '@web/utils';
import { InvoiceNumber } from '../types';

export class OrderRefundCollectionItem {
  public constructor(
    private readonly data: {
      type: RefundType;
      status: RefundStatus;
      description: string;
      refundedPrice: number;
      createdAt: Date;
      finalizedAt?: Nillable<Date>;
      cancelledAt?: Nillable<Date>;
      number: RefundNumber;
      invoiceNumber?: Nillable<InvoiceNumber>;
      invoiceId?: Nillable<Guid>;
    },
  ) {}

  public get number(): RefundNumber {
    return this.data.number;
  }

  public get type(): RefundType {
    return this.data.type;
  }

  public get invoiceNumber(): Nillable<InvoiceNumber> {
    return this.data.invoiceNumber;
  }

  public get invoiceId(): Nillable<Guid> {
    return this.data.invoiceId;
  }

  public get status(): RefundStatus {
    return this.data.status;
  }

  public get description(): string {
    return this.data.description;
  }

  public get refundedPrice(): number {
    return this.data.refundedPrice;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get finalizedAt(): Nillable<Date> {
    return this.data.finalizedAt;
  }

  public get cancelledAt(): Nillable<Date> {
    return this.data.cancelledAt;
  }
}
